import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  changeWtsPositionSelected,
  createWtsPositions,
  updateWtsPositions,
} = Actions;

const WtsPositionsModal = ({mode, positionToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const positionSelected = useSelector((state) => state.wtsPositions.positionSelected);

  const onChangeValues = (value) => {
    const changedPositionSelected = {...positionSelected, 'code': value.toUpperCase()};
    dispatch(changeWtsPositionSelected(changedPositionSelected));
  };

  const showPositionModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsPositionSelected({...positionToEdit}));
    } else {
      dispatch(changeWtsPositionSelected({'code': '', 'status': 'A'}));
    }
  };

  const savePosition = (e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsPositions(areaSelected.id, {'data': positionSelected}));
    } else {
      const data = {
        'code': positionToEdit.code,
        'newCode': positionSelected.code,
        'status': positionSelected.status,
      };
      dispatch(updateWtsPositions(areaSelected.id, {'data': data}));
    }
    showPositionModal(e, false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showPositionModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showPositionModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Cargo' : 'Editar Cargo'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showPositionModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Cargo"
                value={positionSelected?.code || ''}
                onChange={(e, {value}) => onChangeValues(value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => savePosition(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsPositionsModal;
